// extracted by mini-css-extract-plugin
export default {"TableIcon":"TableIconDark__TableIcon___b+PdQ"};